import sortAlphabeticalNoSymbol from "../utility/sortAlphabeticalNoSymbol";
import { adpIternationalProduct } from "../utility/articlesUtils";

function fulfillRoutes(routes) {
    return routes.map((route) => {
        if (route.hasChildren && route.children) {
            // recursively calls for children routes
            route.children = fulfillRoutes(route.children);
        }

        if (route.pathname) {
            route.href = route.pathname
        }

        return route;
    })
}

function buildNorthAmericaOfferings(productsData, featured) {

    let naProducts = productsData && productsData.length > 0 ?
    productsData.filter((product) => !!product.northAmericaOffering && product.isPopular === !!featured).map((product) => {
        return {
					id: product.key,
	        title: product.title,
          pathname:`/apis/api-explorer/${product.key}`
        }
    })
    :
    [{
        id: 'hcm-offrg-wfn',
        title: 'ADP Workforce Now®',
        pathname: '/apis/api-explorer/hcm-offrg-wfn'
    }];

    if (naProducts.length === 0) {
        return null;
    } else if (!featured) {
        naProducts = naProducts.sort(sortAlphabeticalNoSymbol);
    }

    return {
        id: `apis-na${featured ? '-featured' : ''}`,
        title: `${featured ? "Featured" : "Additional"} APIs (North America)`,
        hasChildren: true,
        children: [
        ...naProducts
        ]
    }
}

export function viewAllInternationalGuidesPath(productsData) {
    const fromApiTitles = productsData && productsData.length > 0
        ? productsData
            .filter((product) => !!product.internationalOffering)
            .map((product) => product.title)
        : [];

    // adpIternationalProduct is the canonical list of all international SORs shown
    // in the dropdown. Some may not be returned by the products API (no API Explorer
    // entries or missing internationalOffering flag in DB), so we merge both sources
    // to ensure everything in the dropdown is pre-checked on this page.
    const fromDropdownValues = adpIternationalProduct.map((product) => product.value);

    const intProductTitles = [
        ...new Set([...fromApiTitles, ...fromDropdownValues])
    ].map(encodeURIComponent);

    if (intProductTitles.length === 0) {
        return '/guides/api-guides';
    }

    return `/guides/api-guides?adpProductsInt=${intProductTitles.join('&adpProductsInt=')}`;
}

function buildInternationalOfferings(productsData) {

    const intProducts = productsData && productsData.length > 0 ?
    productsData.filter((product) => !!product.internationalOffering)
    .sort(sortAlphabeticalNoSymbol).map((product) => {
        return {
            id: product.key,
            title: product.title,
            pathname:`/apis/api-explorer/${product.key}`
        }
    })
    :
    [{
        id: 'pr-offrg-adp.link.prem',
        title: 'ADP® Link',
        pathname: '/apis/api-explorer/pr-offrg-adp.link.prem'
    }];

    if (intProducts.length === 0) {
        return null;
    }

    return {
        id: 'apis-int-featured',
        title: 'Featured APIs (International)',
        hasChildren: true,
        children: [
            ...intProducts
        ]
    }

}

function getApiSubMenu(productsData){
    let naMenu;
    let naFeaturedMenu;
    let intFeaturedMenu;

    naFeaturedMenu = buildNorthAmericaOfferings(productsData, true);
    naMenu = buildNorthAmericaOfferings(productsData);
    intFeaturedMenu = buildInternationalOfferings(productsData);

    const apiSubMenuChildren = [
        {
            id: 'api-explorer',
            title: 'API Explorer',
            hasChildren: true,
            children: [
                {
                    id: 'apis-discover',
                    title: 'Discover ADP API integrations',
                    pathname: '/apis/api-explorer'
                }
            ]
        }
    ];



    const addIfTruthy = (array, item) => {
        if (item) {
            array.push(item);
        }
    }

    addIfTruthy(apiSubMenuChildren, naFeaturedMenu)
    addIfTruthy(apiSubMenuChildren, naMenu)
    addIfTruthy(apiSubMenuChildren, intFeaturedMenu)

    return apiSubMenuChildren;
}

const getSolutionsSubMenu = (elasticData, claraDomains) => {
  const naSolutions =
    elasticData?.hits?.hits
      .filter(({ _source: source }) => source.region === "North America")
      .map(({ _id: id, _index: index, _source: source }) => ({
        id,
        title: source.title,
        pathname: `/solutions/${index}/${id}`,
      })) || [];

  // International solutions come exclusively from Databricks (claraDomains).
  // Never fall back to Elasticsearch — ES _id values are "integration-solution-XX"
  // slugs that produce 404s when used as Clara domain UUIDs.
  const intSolutions = claraDomains && claraDomains.length > 0
      ? claraDomains
          .map((domain) => ({
            id: domain.id,
            title: domain.domain_name,
            pathname: `/solutions/clara/${domain.id}`,
          }))
          .sort(sortAlphabeticalNoSymbol)
      : [];

  return [
    {
      id: "solutions-na",
      title: "Solutions for North America Products",
      hasChildren: true,
      children: naSolutions,
    },
    {
      id: "solutions-international",
      title: "Integration Domains for Global Products",
      hasChildren: true,
      children: intSolutions,
    },
  ];
};


export default function getMenu(productsData = [], elasticData = {}, claraDomains = []) {


    const appRoutes = [
        {
            id: 'home',
            title: 'Home',
            pathname: '/'
        },
        {
            id: 'getting-started',
            title: 'Getting started',
            hasChildren: true,
            children: [
                {
                    id: 'getting-started_0',
                    title: 'API Central Clients',
                    hasChildren: true,
                    children: [
                        {
                            id: 'client-integration-overview',
                            title: 'Client integration overview',
                            pathname: '/getting-started/client-integration-overview',
                        },
                        {
                            id: 'getting-started-as-a-client',
                            title: 'Getting started as a client',
                            pathname: '/getting-started/getting-started-as-a-client/guides/api-guides/api-central-quick-start-guide',
                        }
                    ]
                },
                {
                    id: 'getting-started_1',
                    title: 'ADP Marketplace Partners',
                    hasChildren: true,
                    children: [
                        {
                            id: 'partner-integration-overview',
                            title: 'Partner integration overview',
                            pathname: '/getting-started/partner-integration-overview',
                        },
                        {
                            id: 'getting-started-as-a-partner',
                            title: 'Getting started as a partner',
                            pathname: '/getting-started/getting-started-as-a-partner/guides/adp-marketplace-integration-guides/partner-development-learning-guide',
                        }
                    ]
                },
                {
                    id: 'getting-started_3',
                    title: 'ADP Embedded Payroll',
                    hasChildren: true,
                    children: [
                        {
                            id: 'embedded-payroll-overview',
                            title: 'Embedded Payroll Overview',
                            pathname: '/getting-started/embedded-payroll',
                        },
                        {
                            id: 'developer-documentation',
                            title: 'Developer Documentation',
                            pathname: 'https://adpembeddedpayroll.readme.io/docs/overview-1',
                        },
                    ]
                },
                {
                    id: 'getting-started_2',
                    title: 'Key Concepts',
                    hasChildren: true,
                    children: [
                        {
                            id: 'articles',
                            title: 'Learn about API Basics, Usage, Security and Troubleshooting',
                            pathname: '/getting-started/key-concepts',
                        }
                    ]
                },
            ]
        },
        {
            id: 'apis',
            title: 'APIs',
            hasChildren: true,
            expanded: true,
            children: getApiSubMenu(productsData)
        },
        {
            id: 'guides',
            title: 'Guides',
            hasChildren: true,
            expanded: true,
            children: [
                {
                    id: 'quick-start-guides',
                    title: 'Quickstart Guides',
                    hasChildren: true,
                    children: [
                        {
                            id: 'api-central-guide',
                            title: 'ADP API Central for clients',
                            pathname: '/guides/quick-start-guides/adp-api-central-for-clients/api-guides/api-central-quick-start-guide'
                        },
                        {
                            id: 'partner-guide',
                            title: 'ADP Marketplace partners',
                            pathname: '/guides/quick-start-guides/adp-marketplace-partners/adp-marketplace-integration-guides/partner-development-learning-guide'
                        }
                    ]
                },
                {
                    id: 'api-guides-all',
                    title: 'API Guides',
                    hasChildren: true,
                    children: [
                        {
                            id: 'api-guides-all-child',
                            title: 'View All API Guides',
                            pathname: '/guides/api-guides',
                        }
                    ]
                },
                {
                    id: 'api-guides-international',
                    title: 'API Guides (International)',
                    hasChildren: true,
                    children: [
                        {
                            id: 'api-guides-international-all',
                            title: 'View All API Guides (International)',
                            pathname: viewAllInternationalGuidesPath(productsData),
                        }
                    ]
                },
                {
                    id: 'api-guides-na',
                    title: 'API Guides by Data Type (North America)',
                    hasChildren: true,
                    children: [
                        {
                            id: 'guides-na-benefits-usecase',
                            title: 'Benefit Management',
                            pathname: '/guides/api-guides?useCaseTags=Benefit-Management',
                        },
                        {
                            id: 'guides-na-human-resources-usecase',
                            title: 'Human Resources',
                            pathname: '/guides/api-guides?useCaseTags=Human-Resources',
                        },
                        {
                            id: 'guides-na-payroll-management-usecase',
                            title: 'Payroll Management',
                            pathname: '/guides/api-guides?useCaseTags=Payroll-Management',
                        },
                        {
                            id: 'guides-na-recruiting-usecase',
                            title: 'Recruiting',
                            pathname: '/guides/api-guides?useCaseTags=Recruiting',
                        },
                        {
                            id: 'guides-na-time-labor-management-usecase',
                            title: 'Time & Labor Management',
                            pathname: '/guides/api-guides?useCaseTags=Time-Labor-Management',
                        }
                    ]
                },
                {
                    id: 'adp-guides-marketplace-integration-guides',
                    title: 'ADP Marketplace Integration Guides',
                    hasChildren: true,
                    children: [
                        {
                            id: 'guides-mkpl-authentication-and-security-onboarding',
                            title: 'Authentication and Security',
                            pathname: '/guides/adp-marketplace-integration-guides?mkplIntegrationCategory=Authentication-and-Security',
                        },
                        {
                            id: 'guides-mkpl-International-Marketplace',
                            title: 'International',
                            pathname: '/guides/adp-marketplace-integration-guides?mkplIntegrationCategory=International',
                        },
                        {
                            id: 'guides-mkpl-marketing-and-sales',
                            title: 'Marketing and Sales',
                            pathname: '/guides/adp-marketplace-integration-guides?mkplIntegrationCategory=Marketing-and-Sales',
                        },
                        {
                            id: 'guides-mkpl-partner-onboarding',
                            title: 'Partner Onboarding',
                            pathname: '/guides/adp-marketplace-integration-guides?mkplIntegrationCategory=Partner-Onboarding',
                        },
                        {
                            id: 'guides-mkpl-single-sign-on',
                            title: 'Single Sign-On',
                            pathname: '/guides/adp-marketplace-integration-guides?mkplIntegrationCategory=Single-Sign-On',
                        },
                        {
                            id: 'guides-mkpl-marketplace-integration',
                            title: 'Storefront Integration',
                            pathname: '/guides/adp-marketplace-integration-guides?mkplIntegrationCategory=Storefront-Integration',
                        },
                        {
                            id: 'guides-mkpl',
                            title: 'View All ADP Marketplace Integration Guides',
                            pathname: '/guides/adp-marketplace-integration-guides',
                        },
                    ]
                }
            ]
        },
        {
            id: 'solutions',
            title: 'Solutions',
            hasChildren: true,
            expanded: true,
            children: getSolutionsSubMenu(elasticData, claraDomains)
        },
        {
            id: 'support',
            title: 'Support',
            pathname: '/support/help-center',

        }
    ];

    return [
        {
            appRoutes: fulfillRoutes(appRoutes),
        },
    ];
}